import { INTERP, PERIOD } from '../../../constants/shared/CommonConstants';
import { GRADE } from '../../../constants/shared/GradesConstants';
import { MEASURE } from '../../../constants/reading/MeasuresConstants';

const { BOY, MOY, EOY } = PERIOD;
const { YELLOW, GREEN } = INTERP;
const {
    KINDERGARTEN,
    FIRST_GRADE,
    SECOND_GRADE,
    THIRD_GRADE,
    FOURTH_GRADE,
    FIFTH_GRADE,
    SIXTH_GRADE,
} = GRADE;
const { PSF, NWF_CLS, NWF_WRC, MAZE, ORF, ORF_ACC } = MEASURE;

const PmThresholdsMapper = {
    [KINDERGARTEN]: {
        [BOY]: {
            [PSF]: [
                {
                    score: 29,
                    interp: GREEN,
                },
                {
                    score: 1,
                    interp: YELLOW,
                },
            ],
            [NWF_CLS]: [
                {
                    score: 25,
                    interp: GREEN,
                },
                {
                    score: 4,
                    interp: YELLOW,
                },
            ],
            [NWF_WRC]: [
                {
                    score: 3,
                    interp: GREEN,
                },
                {
                    score: 0,
                    interp: YELLOW,
                },
            ],
        },
        [MOY]: {
            [PSF]: [
                {
                    score: 44,
                    interp: GREEN,
                },
                {
                    score: 23,
                    interp: YELLOW,
                },
            ],
            [NWF_CLS]: [
                {
                    score: 31,
                    interp: GREEN,
                },
                {
                    score: 16,
                    interp: YELLOW,
                },
            ],
            [NWF_WRC]: [
                {
                    score: 7,
                    interp: GREEN,
                },
                {
                    score: 1,
                    interp: YELLOW,
                },
            ],
        },
        [EOY]: {
            [PSF]: [
                {
                    score: 44,
                    interp: GREEN,
                },
                {
                    score: 37,
                    interp: YELLOW,
                },
            ],
            [NWF_CLS]: [
                {
                    score: 31,
                    interp: GREEN,
                },
                {
                    score: 24,
                    interp: YELLOW,
                },
            ],
            [NWF_WRC]: [
                {
                    score: 7,
                    interp: GREEN,
                },
                {
                    score: 4,
                    interp: YELLOW,
                },
            ],
        },
    },
    [FIRST_GRADE]: {
        [BOY]: {
            [PSF]: [
                {
                    score: 43,
                    interp: GREEN,
                },
                {
                    score: 19,
                    interp: YELLOW,
                },
            ],
            [NWF_CLS]: [
                {
                    score: 52,
                    interp: GREEN,
                },
                {
                    score: 25,
                    interp: YELLOW,
                },
            ],
            [NWF_WRC]: [
                {
                    score: 14,
                    interp: GREEN,
                },
                {
                    score: 1,
                    interp: YELLOW,
                },
            ],
            [ORF]: [
                {
                    score: 21,
                    interp: GREEN,
                },
                {
                    score: 5,
                    interp: YELLOW,
                },
            ],
            [ORF_ACC]: [
                {
                    score: 87,
                    interp: GREEN,
                },
                {
                    score: 41,
                    interp: YELLOW,
                },
            ],
        },
        [MOY]: {
            [PSF]: [
                {
                    score: 45,
                    interp: GREEN,
                },
                {
                    score: 34,
                    interp: YELLOW,
                },
            ],
            [NWF_CLS]: [
                {
                    score: 55,
                    interp: GREEN,
                },
                {
                    score: 41,
                    interp: YELLOW,
                },
            ],
            [NWF_WRC]: [
                {
                    score: 15,
                    interp: GREEN,
                },
                {
                    score: 10,
                    interp: YELLOW,
                },
            ],
            [ORF]: [
                {
                    score: 39,
                    interp: GREEN,
                },
                {
                    score: 10,
                    interp: YELLOW,
                },
            ],
            [ORF_ACC]: [
                {
                    score: 91,
                    interp: GREEN,
                },
                {
                    score: 54,
                    interp: YELLOW,
                },
            ],
        },
        [EOY]: {
            [PSF]: [
                {
                    score: 45,
                    interp: GREEN,
                },
                {
                    score: 37,
                    interp: YELLOW,
                },
            ],
            [NWF_CLS]: [
                {
                    score: 55,
                    interp: GREEN,
                },
                {
                    score: 45,
                    interp: YELLOW,
                },
            ],
            [NWF_WRC]: [
                {
                    score: 15,
                    interp: GREEN,
                },
                {
                    score: 11,
                    interp: YELLOW,
                },
            ],
            [ORF]: [
                {
                    score: 39,
                    interp: GREEN,
                },
                {
                    score: 26,
                    interp: YELLOW,
                },
            ],
            [ORF_ACC]: [
                {
                    score: 91,
                    interp: GREEN,
                },
                {
                    score: 85,
                    interp: YELLOW,
                },
            ],
        },
    },
    [SECOND_GRADE]: {
        [BOY]: {
            [NWF_CLS]: [
                {
                    score: 68,
                    interp: GREEN,
                },
                {
                    score: 41,
                    interp: YELLOW,
                },
            ],
            [NWF_WRC]: [
                {
                    score: 20,
                    interp: GREEN,
                },
                {
                    score: 10,
                    interp: YELLOW,
                },
            ],
            [ORF]: [
                {
                    score: 78,
                    interp: GREEN,
                },
                {
                    score: 29,
                    interp: YELLOW,
                },
            ],
            [ORF_ACC]: [
                {
                    score: 96,
                    interp: GREEN,
                },
                {
                    score: 84,
                    interp: YELLOW,
                },
            ],
            [MAZE]: [
                {
                    score: 9.0,
                    interp: GREEN,
                },
                {
                    score: 2.5,
                    interp: YELLOW,
                },
            ],
        },
        [MOY]: {
            [NWF_CLS]: [
                {
                    score: 76,
                    interp: GREEN,
                },
                {
                    score: 54,
                    interp: YELLOW,
                },
            ],
            [NWF_WRC]: [
                {
                    score: 22,
                    interp: GREEN,
                },
                {
                    score: 15,
                    interp: YELLOW,
                },
            ],
            [ORF]: [
                {
                    score: 94,
                    interp: GREEN,
                },
                {
                    score: 59,
                    interp: YELLOW,
                },
            ],
            [ORF_ACC]: [
                {
                    score: 96,
                    interp: GREEN,
                },
                {
                    score: 91,
                    interp: YELLOW,
                },
            ],
            [MAZE]: [
                {
                    score: 9.5,
                    interp: GREEN,
                },
                {
                    score: 6.5,
                    interp: YELLOW,
                },
            ],
        },
        [EOY]: {
            [NWF_CLS]: [
                {
                    score: 76,
                    interp: GREEN,
                },
                {
                    score: 54,
                    interp: YELLOW,
                },
            ],
            [NWF_WRC]: [
                {
                    score: 22,
                    interp: GREEN,
                },
                {
                    score: 17,
                    interp: YELLOW,
                },
            ],
            [ORF]: [
                {
                    score: 94,
                    interp: GREEN,
                },
                {
                    score: 77,
                    interp: YELLOW,
                },
            ],
            [ORF_ACC]: [
                {
                    score: 96,
                    interp: GREEN,
                },
                {
                    score: 91,
                    interp: YELLOW,
                },
            ],
            [MAZE]: [
                {
                    score: 9.5,
                    interp: GREEN,
                },
                {
                    score: 7.0,
                    interp: YELLOW,
                },
            ],
        },
    },
    [THIRD_GRADE]: {
        [BOY]: {
            [NWF_CLS]: [
                {
                    score: 94,
                    interp: GREEN,
                },
                {
                    score: 52,
                    interp: YELLOW,
                },
            ],
            [NWF_WRC]: [
                {
                    score: 30,
                    interp: GREEN,
                },
                {
                    score: 18,
                    interp: YELLOW,
                },
            ],
            [ORF]: [
                {
                    score: 105,
                    interp: GREEN,
                },
                {
                    score: 55,
                    interp: YELLOW,
                },
            ],
            [ORF_ACC]: [
                {
                    score: 96,
                    interp: GREEN,
                },
                {
                    score: 91,
                    interp: YELLOW,
                },
            ],
            [MAZE]: [
                {
                    score: 12.0,
                    interp: GREEN,
                },
                {
                    score: 5.0,
                    interp: YELLOW,
                },
            ],
        },
        [MOY]: {
            [NWF_CLS]: [
                {
                    score: 105,
                    interp: GREEN,
                },
                {
                    score: 78,
                    interp: YELLOW,
                },
            ],
            [NWF_WRC]: [
                {
                    score: 31,
                    interp: GREEN,
                },
                {
                    score: 23,
                    interp: YELLOW,
                },
            ],
            [ORF]: [
                {
                    score: 114,
                    interp: GREEN,
                },
                {
                    score: 85,
                    interp: YELLOW,
                },
            ],
            [ORF_ACC]: [
                {
                    score: 96,
                    interp: GREEN,
                },
                {
                    score: 91,
                    interp: YELLOW,
                },
            ],
            [MAZE]: [
                {
                    score: 15.5,
                    interp: GREEN,
                },
                {
                    score: 9.5,
                    interp: YELLOW,
                },
            ],
        },
        [EOY]: {
            [NWF_CLS]: [
                {
                    score: 105,
                    interp: GREEN,
                },
                {
                    score: 80,
                    interp: YELLOW,
                },
            ],
            [NWF_WRC]: [
                {
                    score: 31,
                    interp: GREEN,
                },
                {
                    score: 24,
                    interp: YELLOW,
                },
            ],
            [ORF]: [
                {
                    score: 114,
                    interp: GREEN,
                },
                {
                    score: 96,
                    interp: YELLOW,
                },
            ],
            [ORF_ACC]: [
                {
                    score: 96,
                    interp: GREEN,
                },
                {
                    score: 91,
                    interp: YELLOW,
                },
            ],
            [MAZE]: [
                {
                    score: 15.5,
                    interp: GREEN,
                },
                {
                    score: 12.0,
                    interp: YELLOW,
                },
            ],
        },
    },
    [FOURTH_GRADE]: {
        [BOY]: {
            [ORF]: [
                {
                    score: 121,
                    interp: GREEN,
                },
                {
                    score: 62,
                    interp: YELLOW,
                },
            ],
            [ORF_ACC]: [
                {
                    score: 96,
                    interp: GREEN,
                },
                {
                    score: 91,
                    interp: YELLOW,
                },
            ],
            [MAZE]: [
                {
                    score: 16.5,
                    interp: GREEN,
                },
                {
                    score: 11.0,
                    interp: YELLOW,
                },
            ],
        },
        [MOY]: {
            [ORF]: [
                {
                    score: 125,
                    interp: GREEN,
                },
                {
                    score: 98,
                    interp: YELLOW,
                },
            ],
            [ORF_ACC]: [
                {
                    score: 96,
                    interp: GREEN,
                },
                {
                    score: 91,
                    interp: YELLOW,
                },
            ],
            [MAZE]: [
                {
                    score: 17.0,
                    interp: GREEN,
                },
                {
                    score: 13.0,
                    interp: YELLOW,
                },
            ],
        },
        [EOY]: {
            [ORF]: [
                {
                    score: 125,
                    interp: GREEN,
                },
                {
                    score: 99,
                    interp: YELLOW,
                },
            ],
            [ORF_ACC]: [
                {
                    score: 96,
                    interp: GREEN,
                },
                {
                    score: 91,
                    interp: YELLOW,
                },
            ],
            [MAZE]: [
                {
                    score: 17.0,
                    interp: GREEN,
                },
                {
                    score: 14.0,
                    interp: YELLOW,
                },
            ],
        },
    },
    [FIFTH_GRADE]: {
        [BOY]: {
            [ORF]: [
                {
                    score: 122,
                    interp: GREEN,
                },
                {
                    score: 81,
                    interp: YELLOW,
                },
            ],
            [ORF_ACC]: [
                {
                    score: 96,
                    interp: GREEN,
                },
                {
                    score: 91,
                    interp: YELLOW,
                },
            ],
            [MAZE]: [
                {
                    score: 17.0,
                    interp: GREEN,
                },
                {
                    score: 10.5,
                    interp: YELLOW,
                },
            ],
        },
        [MOY]: {
            [ORF]: [
                {
                    score: 137,
                    interp: GREEN,
                },
                {
                    score: 108,
                    interp: YELLOW,
                },
            ],
            [ORF_ACC]: [
                {
                    score: 96,
                    interp: GREEN,
                },
                {
                    score: 91,
                    interp: YELLOW,
                },
            ],
            [MAZE]: [
                {
                    score: 21.0,
                    interp: GREEN,
                },
                {
                    score: 14.5,
                    interp: YELLOW,
                },
            ],
        },
        [EOY]: {
            [ORF]: [
                {
                    score: 137,
                    interp: GREEN,
                },
                {
                    score: 124,
                    interp: YELLOW,
                },
            ],
            [ORF_ACC]: [
                {
                    score: 96,
                    interp: GREEN,
                },
                {
                    score: 91,
                    interp: YELLOW,
                },
            ],
            [MAZE]: [
                {
                    score: 21.0,
                    interp: GREEN,
                },
                {
                    score: 18.0,
                    interp: YELLOW,
                },
            ],
        },
    },
    [SIXTH_GRADE]: {
        [BOY]: {
            [ORF]: [
                {
                    score: 133,
                    interp: GREEN,
                },
                {
                    score: 99,
                    interp: YELLOW,
                },
            ],
            [ORF_ACC]: [
                {
                    score: 96,
                    interp: GREEN,
                },
                {
                    score: 91,
                    interp: YELLOW,
                },
            ],
            [MAZE]: [
                {
                    score: 19.5,
                    interp: GREEN,
                },
                {
                    score: 12.5,
                    interp: YELLOW,
                },
            ],
        },
        [MOY]: {
            [ORF]: [
                {
                    score: 141,
                    interp: GREEN,
                },
                {
                    score: 117,
                    interp: YELLOW,
                },
            ],
            [ORF_ACC]: [
                {
                    score: 96,
                    interp: GREEN,
                },
                {
                    score: 91,
                    interp: YELLOW,
                },
            ],
            [MAZE]: [
                {
                    score: 26.5,
                    interp: GREEN,
                },
                {
                    score: 15.0,
                    interp: YELLOW,
                },
            ],
        },
        [EOY]: {
            [ORF]: [
                {
                    score: 141,
                    interp: GREEN,
                },
                {
                    score: 125,
                    interp: YELLOW,
                },
            ],
            [ORF_ACC]: [
                {
                    score: 96,
                    interp: GREEN,
                },
                {
                    score: 91,
                    interp: YELLOW,
                },
            ],
            [MAZE]: [
                {
                    score: 26.5,
                    interp: GREEN,
                },
                {
                    score: 20.5,
                    interp: YELLOW,
                },
            ],
        },
    },
};

export default PmThresholdsMapper;
